//Helper for goal result cards
export const checkShouldCustomiseGoal = (tb, targetBehaviours) => {
  const noEvents = targetBehaviours
    ? targetBehaviours.every((tb) => tb.eligibleOperator === 0)
    : false;

  const open = tb?.isOpenPeriod;
  if (!!open) return null;
  const result = !!noEvents
    ? "none"
    : tb.eligibleOperator === 0
      ? "excluded"
      : tb.eligibleOperator === 1 && tb.succeeded === 0
        ? "excluded"
        : tb.eligibleOperator === 1 && tb.succeeded === 1
          ? "one"
          : null;
  return result;
};
